/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_a185e16e"]'><cube-button>默认按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_a185e16e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_a185e16e"}
  /** script content **/
  require("./btn-secondary.mpx.js?isComponent&outputPath=components%2Fbtn-secondarya185e16e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-secondary.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-secondarya185e16e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_a185e16e"],
    ctorType: "component",
    outputPath: "components/btn-secondarya185e16e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>